import { type DependencyList, useMemo } from 'react';
import { useStore } from 'effector-react';
import { $isCn } from '@stores/langStores';

function useLangString<T extends string>(
  langMap: Record<T, [string, string]>,
  deps: DependencyList
) {
  const isCn = useStore($isCn);
  const index = isCn ? 0 : 1;
  return useMemo(() => {
    return Object.keys(langMap).reduce(
      (result, key: T) => {
        result[key] = langMap[key][index];
        return result;
      },
      {} as Record<T, string>
    );
  }, [...deps, index]);
}

export default useLangString;
